<template>
    <div class="flex flex-row flex-wrap items-stretch">
        <button id="decrease" class="btn btn-default btn-primary flex justify-center w-8" :disabled="count <= minCount"
                @click.prevent="decrease">
            <span class="self-center text-xl">-</span>
        </button>
        <input
            id="number"
            type="number"
            class="text-center py-2 w-8"
            :min="minCount"
            :value="value"
            @input="$emit('input', $event.target.value)"
        >
        <button id="increase" class="btn btn-default btn-primary flex justify-center w-8" @click.prevent="increase">
            <span class="self-center text-xl">+</span>
        </button>
    </div>
</template>

<script>
  export default {
    name: 'CounterField',

    props: {
      value: {
        type: [String, Number],
        default: 1,
      },
      minCount: {
        type: [String, Number],
        default: 1,
      },
    },

    data() {
      return {
        count: 1,
      };
    },

    watch: {
      value: {
        handler: 'updateValue',
        immediate: true,
      },
    },

    methods: {
      updateValue() {
        if (this.count !== parseInt(this.value, 10)) {
          this.count = parseInt(this.value, 10);
        }
      },
      emitResult() {
        this.$emit('input', this.count);
      },
      increase() {
        this.count += 1;
        this.emitResult();
      },

      decrease() {
        this.count -= 1;
        this.emitResult();
      },
    },
  };
</script>

<style scoped>

</style>
